import { Module } from 'vuex';

import { CONTAINER, TYPES } from '../../config';

import { AppState } from '../../models';

import { StorageService } from '../../services';

import { AddPlayedAnimationAction } from './actions/add-played-animation.action';
import { SetAlreadyLoggedInOnceAction } from './actions/set-already-logged-In-once.action';
import { SetFiltersHiddenAction } from './actions/set-filters-hidden.action';
import { SetFullscreenAction } from './actions/set-fullscreen.action';
import { SetMenuCollapsedAction } from './actions/set-menu-collapsed.action';
import { APP_CONSTS } from './app.consts';
import { AlreadyLoggedInOnceGetter } from './getters/already-logged-in-once.getter';
import { FeaturesTreeGetter } from './getters/features-tree.getter';
import { FiltersHiddenGetter } from './getters/filters-hidden.getter';
import { FullscreenGetter } from './getters/fullscreen.getter';
import { MenuCollapsedGetter } from './getters/menu-collapsed.getter';
import { PlayedAnimationsGetter } from './getters/stepped-animations-played.getter';
import { AddPlayedAnimationMutation } from './mutations/add-played-animation.mutation';
import { SetAlreadyLoggedInOnceMutation } from './mutations/set-already-logged-in-once.mutation';
import { SetFiltersHiddenMutation } from './mutations/set-filters-hidden.mutation';
import { SetFullscreenMutation } from './mutations/set-fullscreen.mutation';
import { SetMenuCollapsedMutation } from './mutations/set-menu-collapsed.mutation';

export const APP_MODULE: Module<AppState, any> = {
  namespaced: true,

  state: (): AppState => {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService);
    const alreadyLoggedInOnceValue = storageService.getItem(APP_CONSTS.storage.alreadyLoggedInOnce);
    const menuCollapsedStorageValue = storageService.getItem(APP_CONSTS.storage.menuCollapsed);

    return {
      fullscreen: false,
      alreadyLoggedInOnce: (alreadyLoggedInOnceValue !== null ? (alreadyLoggedInOnceValue === 'true') : false),
      menuCollapsed: (menuCollapsedStorageValue !== null ? (menuCollapsedStorageValue === 'true') : false),
      filtersHidden: false,
      playedAnimations: []
    };
  },

  getters: {
    [APP_CONSTS.getters.featuresTree]: FeaturesTreeGetter.execute,
    [APP_CONSTS.getters.fullscreen]: FullscreenGetter.execute,
    [APP_CONSTS.getters.alreadyLoggedInOnce]: AlreadyLoggedInOnceGetter.execute,
    [APP_CONSTS.getters.menuCollapsed]: MenuCollapsedGetter.execute,
    [APP_CONSTS.getters.filtersHidden]: FiltersHiddenGetter.execute,
    [APP_CONSTS.getters.playedAnimations]: PlayedAnimationsGetter.execute
  },

  actions: {
    [APP_CONSTS.actions.setFullscreen]: SetFullscreenAction.execute,
    [APP_CONSTS.actions.setAlreadyLoggedInOnce]: SetAlreadyLoggedInOnceAction.execute,
    [APP_CONSTS.actions.setMenuCollapsed]: SetMenuCollapsedAction.execute,
    [APP_CONSTS.actions.setFiltersHidden]: SetFiltersHiddenAction.execute,
    [APP_CONSTS.actions.addPlayedAnimation]: AddPlayedAnimationAction.execute
  },

  mutations: {
    [APP_CONSTS.mutations.setFullscreen]: SetFullscreenMutation.execute,
    [APP_CONSTS.mutations.setAlreadyLoggedInOnce]: SetAlreadyLoggedInOnceMutation.execute,
    [APP_CONSTS.mutations.setMenuCollapsed]: SetMenuCollapsedMutation.execute,
    [APP_CONSTS.mutations.setFiltersHidden]: SetFiltersHiddenMutation.execute,
    [APP_CONSTS.mutations.addPlayedAnimation]: AddPlayedAnimationMutation.execute
  }

};
